
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CommissionOffer } from "@/types/commission.types";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";

interface CommissionCardProps {
  offer: CommissionOffer;
}

export function CommissionCard({ offer }: CommissionCardProps) {
  return (
    <Card className="overflow-hidden">
      <div className="relative">
        {offer.examples_urls && offer.examples_urls.length > 0 ? (
          <img 
            src={offer.examples_urls[0]} 
            alt={offer.title} 
            className="w-full h-48 object-cover"
          />
        ) : (
          <div className="w-full h-48 bg-muted flex items-center justify-center">
            <p className="text-muted-foreground">Sem imagem</p>
          </div>
        )}
        <div className="absolute top-2 right-2 flex space-x-2">
          {!offer.is_active && (
            <Badge variant="destructive">Fechado</Badge>
          )}
          {offer.specific_commissions && offer.specific_commissions.length > 0 && (
            <Badge variant="default">{offer.specific_commissions[0]}</Badge>
          )}
        </div>
      </div>
      <CardContent className="p-4">
        <div className="flex items-center gap-3 mb-3">
          <Avatar className="h-10 w-10">
            <AvatarImage src={offer.artist?.avatar_url || ''} />
            <AvatarFallback>{offer.artist?.username?.charAt(0).toUpperCase() || 'A'}</AvatarFallback>
          </Avatar>
          <div>
            <h3 className="font-semibold">{offer.artist?.username || "Artista"}</h3>
            <div className="flex">
              {Array(5).fill(0).map((_, i) => (
                <Star 
                  key={i} 
                  className={`h-3 w-3 ${i < 4 ? "text-yellow-500 fill-yellow-500" : "text-gray-300"}`}
                />
              ))}
            </div>
          </div>
        </div>

        <h3 className="font-bold text-lg">{offer.title}</h3>
        <div>
          {offer.currency_type === 'USD' && (
            <p className="text-amber-500 font-bold">${offer.price_usd.toFixed(2)}+</p>
          )}
          {offer.currency_type === 'BRL' && (
            <p className="text-amber-500 font-bold">R${offer.price_usd.toFixed(2)}+</p>
          )}
          {offer.currency_type === 'EUR' && (
            <p className="text-amber-500 font-bold">€{offer.price_usd.toFixed(2)}+</p>
          )}
          {offer.accept_nft && offer.price_eth > 0 && (
            <p className="text-amber-400 font-bold text-sm">ou Ξ{offer.price_eth.toFixed(4)} ETH</p>
          )}
        </div>
        <p className="text-sm text-muted-foreground mb-3">{offer.delivery_time_days} dias | {offer.max_revision} revisões</p>
        
        <Link to={`/commissions/${offer.id}`}>
          <Button variant="outline" className="w-full mt-2">Ver detalhes</Button>
        </Link>
      </CardContent>
    </Card>
  );
}